import { Controller } from "@hotwired/stimulus"
import { Issue } from "../channels/issue_channel"

// Connects to data-controller="issue-form-monthly-salery"
export default class extends Controller {
  static targets = [
    "baseSaleryTotal",
    "baseSaleryField",
    "gratificationField",
    "childBenefitField",
    "additionalBenefitField"
  ];

  // observer for base salery data
  baseSaleryTotalTargetConnected (evt) {
    this.recalc_base_salery(evt)
  }

  recalc_base_salery (evt) {
    let sum = 0.0
    const fields = [
      "baseSaleryField",
      "gratificationField",
      "childBenefitField",
      "additionalBenefitField",
    ]

    if (evt?.target?.id == 'issue_base_salery') {
      const salary = parseFloat(evt.target.value.replace(/[',]/g, ''))
      if (salary > 0) {
        this.gratificationFieldTarget.value = this.#convert_to_currenty(Math.floor(salary / 12.0))
      }
    }

    fields.forEach((f) => {
      const field = this[ `${ f }Target` ].value
                                          .replace(/[',]/g, '')
      const t = parseFloat(field)
      if (t) sum += t
    })
    this.baseSaleryTotalTarget.value = this.#convert_to_currenty(sum)
  }

  changeSalery (evt) {
    evt.target
       .closest("div")
       .querySelectorAll("a")
       .forEach((e) => {
         e.classList.remove("bg-sky-600/80", "text-white")
       })
    evt.target.classList.add("bg-sky-600/80", "text-white")
    this.saleryTypeFieldTarget.value = evt.params.saleryTypeId
  }

  #convert_to_currenty (val) {
    return new Intl.NumberFormat("de-CH", { minimumFractionDigits: 2 })
                   .format(val)
                   .toString()
  }
}
